<div class="footer-container">
    <div class="footer-container__top">
        <div class="footer-container__top__logo"></div>    
        <div class="footer-container__top__options">
            <div class="footer-container__top__options__option" (click)="goToLegalDiscalimer()">{{'legal-disclaimer.title' | transloco}}</div>
            <div class="footer-container__top__options__option" (click)="goToCookiePolicy()">{{'cookie-policy.title' | transloco}}</div>
        </div>    
    </div>
    <div class="footer-container__pstd" *ngIf="showPstdLogos">
        <img src="/assets/images/logos_pstd.png" alt="PSTD" />
    </div>
    <div class="footer-container__bottom">
        <div class="footer-container__bottom__copyright">{{'copyright.title' | transloco}}</div>
        <div class="footer-container__bottom__version">{{ 'Version: '}}{{version}}</div>
    </div>
</div>
